import React, { createContext, useContext, useState, useCallback } from "react";

const BreadcrumbContext = createContext();

export const BreadcrumbProvider = ({ children }) => {
  const [breadcrumbs, setBreadcrumbsState] = useState(null);

  const setBreadcrumbs = useCallback((crumbs) => {
    setBreadcrumbsState(crumbs);
  }, []);

  const resetBreadcrumbs = useCallback(() => {
    setBreadcrumbsState(null);
  }, []);

  return (
    <BreadcrumbContext.Provider
      value={{
        breadcrumbs,
        setBreadcrumbs,
        resetBreadcrumbs,
      }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error("useBreadcrumb must be used within a BreadcrumbProvider");
  }
  return context;
};

export default BreadcrumbContext;
